import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useCreateServiceVisitTypeMutation } from '../services';
import {
  ServiceVisitTypeFormValues,
  toServiceVisitTypePayload,
} from '../models';

const LIST_PATH = '/business/service-visit-types';

const useCreateServiceVisitType = () => {
  const navigate = useNavigate();
  const { showNotification } = useNotification();

  const [createServiceVisitType, { isLoading: isCreating }] =
    useCreateServiceVisitTypeMutation();

  const handleCreate = useCallback(
    async (values: ServiceVisitTypeFormValues): Promise<void> => {
      try {
        const payload = toServiceVisitTypePayload(values);
        await createServiceVisitType(payload).unwrap();
        showNotification(
          'Tipo de visita creado exitosamente',
          NotificationSeverity.success
        );
        setTimeout(() => navigate(LIST_PATH), 500);
      } catch (error: any) {
        const message =
          error?.data?.message ??
          error?.message ??
          'Error al crear el tipo de visita';
        showNotification(message, NotificationSeverity.error);
      }
    },
    [createServiceVisitType, showNotification, navigate]
  );

  return { handleCreate, isCreating };
};

export default useCreateServiceVisitType;
